module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Blatten_VS-aeb3a6def3e342547b2b9b9bbc8c6d57.svg";